import React from 'react'
import { useIntl } from 'react-intl'
import {
  PanelToggle,
  PANEL_TOGGLE_TITLE_VARIANT_S,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Text
} from 'mailup-web-components'

import { useRecoilState, useSetRecoilState } from 'recoil'
import DynamicFieldsModal from '../DynamicFieldsModal'
import { modalDefaultFields } from '../../../recoil/state/modal'
import { messageState } from '../../../recoil/state/message'

const DynamicFields = () => {
  const intl = useIntl()
  const setModalDefaultFields = useSetRecoilState(modalDefaultFields)
  const [{ useDynamicField }, setUseDynamicField] = useRecoilState(messageState)
  /*   const handleChange = e => {
    const checkState = e.target.checked
    setUseDynamicField(prev => ({
      ...prev,
      useDynamicField: checkState,
      isDirty: true
    }))
  } */

  function handleChangeUseDynamicField(state) {
    setUseDynamicField(prev => ({
      ...prev,
      useDynamicField: !state,
      isDirty: true
    }))
  }

  const handleClick = e => {
    e.preventDefault()
    setModalDefaultFields(true)
  }

  return (
    <>
      <DynamicFieldsModal />
      <PanelToggle
        title={intl.formatMessage({
          id: 'Load.SavedEmailWizard.LabelDynamicFields'
        })}
        titleVariant={PANEL_TOGGLE_TITLE_VARIANT_S}
        checked={useDynamicField}
        onChange={() => handleChangeUseDynamicField(useDynamicField)}
        data-mu-test='overview-message__box-dynamic-fields'
      >
        {useDynamicField && (
          <>
            <Text htmlElement='span'>
              {intl.formatMessage({
                id: 'Load.SavedEmailWizard.LabelModalDynamicFields'
              })}
            </Text>{' '}
            <Link variant={LINK_VARIANT_HIGHLIGHT} onClick={handleClick}>
              {intl.formatMessage({
                id: 'Load.SavedEmailWizard.BtnSetDefaultValueDynamicFields'
              })}
            </Link>
          </>
        )}
      </PanelToggle>
    </>
  )
}

export default DynamicFields
